import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild
} from '@angular/core'
import {
  LibBatteryStatusComponent,
  LibWifiStatusButtonComponent
} from 'design-system'
import { BlockingModalComponent } from 'projects/aiomed/src/app/features/blocking-modal/blocking-modal.component'

@Component({
  selector: 'aiomed-low-charging',
  imports: [
    BlockingModalComponent,
    LibBatteryStatusComponent,
    LibWifiStatusButtonComponent
  ],
  templateUrl: './low-charging.component.html',
  styleUrl: './low-charging.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LowChargingComponent {
  readonly pinCodeInput =
    viewChild<ElementRef<HTMLInputElement>>('pinCodeInput')

  readonly isChargingScreenShown = input.required<boolean>()
  readonly isPoweringScreenShown = input.required<boolean>()
  readonly isBatteryConnectToPowerAndShuttingDownScreenShown =
    input.required<boolean>()
  readonly hasVirtualKeyboard = input.required<boolean>()
  readonly isOnline = input.required<boolean>()
  readonly batteryLevel = input.required<number>()
  readonly isDeviceCharging = input.required<boolean>()
  readonly openWiFiNetworkSettings = output<void>()
  readonly pinCodeCorrectlyEntered = output<void>()
}
